import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMinecraftComponent } from './simple-icons-minecraft.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMinecraftComponent ],
    exports:      [ SimpleIconsMinecraftComponent ],
    bootstrap:    []
})
export class SimpleIconsMinecraftModule {}
